import * as React from "react";
import { Edge, EdgeChildProps } from "reaflow";
import { IconPlus, IconX } from "@tabler/icons-react";

import {
  BaseEdgeDataType,
  BaseEdgePropsType,
  BaseNodeDataType,
} from "../WorkflowUtils";
import { BasePortDataType } from "../Port/BasePort";
import { ActionIcon } from "@mantine/core";

const BaseEdge: React.FunctionComponent<BaseEdgePropsType> = (props) => {
  const {
    id,
    isDisabled,
    selectedEdge,
    onAddNode,
    onDeleteEdge,
    onEdgeClick,
    allNodes,
    allEdges,
  } = props;

  const edge: BaseEdgeDataType = allEdges.find(
    (edge: BaseEdgeDataType) => edge.id === props?.properties?.id
  ) as BaseEdgeDataType;

  if (typeof edge === "undefined") {
    return null;
  }

  const selected = edge.id === selectedEdge?.id;

  return (
    <Edge
      {...props}
      interpolation={"linear"}
      className={"edge-svg-graph"}
      onClick={() => {
        onEdgeClick(edge);
      }}
    >
      {(edgeChildProps: EdgeChildProps) => {
        const { center } = edgeChildProps;
        // Improve centering (because we have 3 icons), and position the foreignObject children above the line
        const x = (center?.x || 0) - 20;
        const y = (center?.y || 0) - 20;

        if (isDisabled || !selected) {
          return <></>;
        }
        return (
          <foreignObject
            id={`edge-foreignObject-${edge.id}`}
            className={"edge-container"}
            width={60}
            height={60}
            x={x}
            y={y}
          >
            {!isDisabled && !edge.parent && selected && (
              <div className={"edge-actions"}>
                <ActionIcon
                  size="sm"
                  variant="transparent"
                  color="gray"
                  onClick={() => {
                    onAddNode(edge);
                  }}
                >
                  <IconPlus />
                </ActionIcon>

                <ActionIcon
                  size="sm"
                  variant="transparent"
                  color="red"
                  onClick={() => {
                    onDeleteEdge(edge);
                  }}
                >
                  <IconX />
                </ActionIcon>
              </div>
            )}
          </foreignObject>
        );
      }}
    </Edge>
  );
};

export default BaseEdge;
